import {
  SET_CONFIG,
  SET_HEADLINE_TITLE,
  SET_HEADLINE_BACK_BUTTON_CONFIG,
  CLEAR_ROUTE_CONFIG,
} from './services.actions';

const initialState = {
  config: {},
  routeConfig: {
    headlineBackButton: {
      title: '',
      path: '',
      prevPath: '',
    },
  },
};

export const servicesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CONFIG:
      return {
        ...state,
        config: payload,
      };
    case SET_HEADLINE_TITLE:
      return {
        ...state,
        config: {
          ...state.config,
          headlineTitle: payload,
        },
      };
    case SET_HEADLINE_BACK_BUTTON_CONFIG: {
      return {
        ...state,
        routeConfig: {
          ...state.routeConfig,
          headlineBackButton: {
            isDisplayed: payload.isDisplayed || state.routeConfig.headlineBackButton.isDisplayed,
            title: payload.title || state.routeConfig.headlineBackButton.title,
            goBack: payload.goBack || state.routeConfig.headlineBackButton.goBack,
          },
        },
      };
    }
    case CLEAR_ROUTE_CONFIG: {
      return {
        ...state,
        routeConfig: initialState.routeConfig,
      };
    }
    default:
      return state;
  }
};
